import { useContext } from 'react';
import { useQuery } from 'urql';

import { graphql } from '@packages/gql/generated/shopping';

import type { SelectedFilterValue } from '../../types';
import { SearchApiRequestContext } from '../../SearchApiRequestContext';

const FilterSubmitButtonDataDocument = graphql(/* GraphQL */ `
  query FilterSubmitButtonData($filterId: ID!, $resultId: ID!) {
    searchFilter(filterId: $filterId, resultId: $resultId) {
      groupedValues {
        values {
          id
          name
        }
      }
    }
  }
`);

export const useFilterTrackingLabels = (
  hasChanges: boolean,
  selectedFilterValues: SelectedFilterValue[],
  filterId?: string,
) => {
  const { requestCacheKey } = useContext(SearchApiRequestContext);

  const variables = {
    // NOTE: filterId is required, but as the query is paused until it is defined, we just use a default value to satisfy the query variables type
    filterId: filterId ?? '',
    resultId: requestCacheKey,
  };

  const [{ data }] = useQuery({
    query: FilterSubmitButtonDataDocument,
    variables,
    pause: !(filterId && hasChanges),
  });

  if (!data) {
    return [''];
  }

  const selectedValueIds = selectedFilterValues
    .filter((value) => value.filterId === filterId)
    .flatMap((value) => value.selectedValues);

  return data.searchFilter.groupedValues
    .flatMap((group) => group.values)
    .filter((value) => selectedValueIds.includes(value.id))
    .map((value) => value.name);
};
